<template>
  <div id="app">
    <Top v-if="$route.path !== '/agreement'"/>
    <router-view />
    <Bottom v-if="$route.path !== '/agreement'"/>
    <el-dialog
      :visible.sync="hostOrigin"
      width="800px"
      :destroy-on-close="true"
      :show-close="false"
      :align-center="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="background-color: #ebf0fa"
    >
      <div class="flex-flex-justify-center">
        <div class="zzlogo"> </div>
      </div>
      <div class="title">ZZ游戏助手域名更新提醒</div>
            <div class="category" style="margin-top: 58px">
              <span>官网地址:</span>
              <span>https://zzyxzs.com</span>
            </div>
      <!--      <div class="category">-->
      <!--        <span>代理商后台:</span>-->
      <!--        <span>https://agent.zzyxzs.com</span>-->
      <!--      </div>-->
<!--      <div class="category">-->
<!--        <span>商户后台:</span>-->
<!--        <span>https://sh.zzyxzs.com</span>-->
<!--      </div>-->
      <div class="flex-flex-justify-center">
        <div class="lz-button" @click="handlerJumpSh">好的</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Top from "@/components/top";
import Bottom from "@/components/bottom";

export default {
  components: {
    Top,
    Bottom,
  },
  data(){
    return {
      hostOrigin: false
    }
  },
  mounted () {
    if (window.location.origin.includes('zzyxzs')) {
      this.hostOrigin = false;
    } else {
      this.hostOrigin = true;
    }
    console.log(this.hostOrigin);
  },
  methods: {
    handlerJumpSh(){
      window.location.href = 'https://zzyxzs.com';
    }
  }
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  background: linear-gradient(to right, #140223, #121f45);
  // width: 100vw;
  // height: 100vh;
  margin: 0 auto;
  // width: 100%;
  overflow: hidden;
}
.title {
  text-align: center;
  font-weight: 700;
  font-size: 36px;
  color: #333333;
  line-height: 36px;
  font-style: normal;
  text-transform: none;
}
.category {
  text-align: center;
  margin-top: 24px;
  :nth-child(1) {
    font-weight: 500;
    font-size: 18px;
    color: #666666;
    line-height: 18px;
    font-style: normal;
    text-transform: none;
    margin-right: 10px;
  }
  :nth-child(2) {
    font-weight: 500;
    font-size: 18px;
    color: #408cff;
    line-height: 18px;
    font-style: normal;
    text-transform: none;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      text-underline-offset: 5px;
    }
  }
}
.lz-button {
  margin-top: 58px;
  margin-bottom: 24px;
  text-align: center;
  cursor: pointer;
  line-height: 56px;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  width: 374px;
  height: 56px;
  background: #8e89e7;
  box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.0197), 0px 7px 5px 0px rgba(0, 0, 0, 0.0283),
  0px 13px 10px 0px rgba(0, 0, 0, 0.035), 0px 22px 18px 0px rgba(0, 0, 0, 0.0417),
  0px 42px 33px 0px rgba(0, 0, 0, 0.0503), 0px 100px 80px 0px rgba(0, 0, 0, 0.07);
  border-radius: 14px 14px 14px 14px;
}
.zzlogo {
  background-image: url('./assets/zzlogo.png');
  background-repeat: no-repeat;
  width: 120px;
  height: 120px;
  margin-bottom: 36px;
}
.flex-flex-justify-center {
  display: flex;
  justify-content: center;
}
</style>
